import { useNavigation } from "react-router";
import { Chart } from "~/components/metrika/Chart";
import { DropList } from "~/components/metrika/DropList";
import { InlineCalendar } from "~/components/metrika/InlineCalendar";
import { Nav } from "~/components/metrika/Nav";
import { Loader } from "~/components/site/Loader";
import { Breadcrumb } from "~/components/ui/Breadcrumb";
import { PageTitle } from "~/components/ui/PageTitle";
import { useT, useTurl } from "~/util/Lang";

type Character = {
  id: number;
  name: string;
};

type Item = {
  id: number;
  itemName: string;
  type: string;
  name: string;
  icon: string;
};

type Loot = {
  date: Date;
  count: number;
  item: Item | null;
  type: "ITEM" | "EXP" | "SP";
};

type Data = {
  timezone: string;
  character: Character;
  loot: Loot[];
  activeDays: string[];
};

export function StatsPage(params: { data: Data; }) {
  const { data } = params;
  const t = useT();
  const turl = useTurl();
  const title = t({ en: "Tracker", ru: "Tracker" });
  const navigation = useNavigation();

  const adena = data.loot.filter(
    (f) => f.type === "ITEM" && f.item && f.item.id === 57
  );
  const exp = data.loot.filter((f) => f.type === "EXP");
  const sp = data.loot.filter((f) => f.type === "SP");
  const items = data.loot.filter((f) => f.type === "ITEM");

  return (
    <div className="content">
      <Breadcrumb
        items={[
          { title, url: turl("/tracker") },
          {
            title: data.character.name,
            url: turl(`/tracker/${data.character.id}/stats`),
          },
        ]}
      />
      <PageTitle>{data.character.name}</PageTitle>
      <Nav character={data.character} />
      <InlineCalendar data={data} />
      <div style={{ position: "relative" }}>
        <div className="columns">
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          >
          </div>
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          >
            <Chart
              data={adena}
              range="24h"
              color="gold"
              prefix="Adena"
              title="Adena Chart"
              timezone={data.timezone}
            />
            <Chart
              data={exp}
              range="24h"
              color="cornflowerblue"
              prefix="EXP"
              title="Experience Chart"
              timezone={data.timezone}
            />

            <Chart
              data={sp}
              range="24h"
              color="aliceblue"
              prefix="SP"
              title="Skill Poins Chart"
              timezone={data.timezone}
            />
          </div>
          <div
            className="column"
            style={{ display: "flex", gap: 20, flexDirection: "column" }}
          >
            <DropList data={items} timezone={data.timezone} />
          </div>
        </div>
        {navigation.state === "loading" ? <Loader /> : null}
      </div>
    </div>
  );
}

